<script lang="ts" setup>
const emit = defineEmits(["close"]);

const userClassroomsData = useUserClassroomsDataStore();
const { classrooms } = storeToRefs(userClassroomsData);

const capabilityService = useCapabilitiesServiceStore();
const { numActiveClassrooms, numAllowedClassrooms } =
  storeToRefs(capabilityService);

const numClassroomsToArchive = computed(() => {
  return numActiveClassrooms.value - numAllowedClassrooms.value;
});

const purchaseClassrooms = () => {
  navigateTo("/configure/subscription");
  emit("close");
};

const isOrganizationClassrooms = computed(() => {
  return classrooms.value.some((classroom) => classroom.organizationId);
});
</script>

<template>
  <div class="w-[600px] overflow-auto max-h-[70vh]">
    <div v-if="numClassroomsToArchive > 0">
      <p>
        Oops! You do not have enough classroom licenses. You have
        {{ numActiveClassrooms }} active classrooms but are licensed for
        {{ numAllowedClassrooms }}. Please archive
        {{ numClassroomsToArchive }}
        {{ numClassroomsToArchive > 1 ? "classrooms" : "classroom" }} or
        {{
          isOrganizationClassrooms
            ? "reach out to your organization's administrator to add more licenses."
            : "purchase additional licenses."
        }}
      </p>
      <BaseButton
        v-if="isOrganizationClassrooms != true"
        @click="purchaseClassrooms"
        class="mt-4"
      >
        Purchase More Classrooms
      </BaseButton>
    </div>
    <div v-if="numClassroomsToArchive <= 0">
      <p>You now have enough classroom licenses.</p>
    </div>
    <div class="mt-4">
      <ClassroomsLicenseReviewItem
        v-for="classroom in classrooms"
        :classroom="classroom"
        class="border-b last:border-none py-2"
      />
    </div>
  </div>
</template>

<style scoped></style>
